import { render, staticRenderFns } from "./DuplicateTypeTable.vue?vue&type=template&id=b93f3f08"
import script from "./DuplicateTypeTable.vue?vue&type=script&lang=ts"
export * from "./DuplicateTypeTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports